var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2382 8.95215H2.76179C1.60459 8.95215 0.666504 9.89024 0.666504 11.0474V17.3333C0.666504 18.4905 1.60459 19.4286 2.76179 19.4286H13.2382C14.3954 19.4286 15.3335 18.4905 15.3335 17.3333V11.0474C15.3335 9.89024 14.3954 8.95215 13.2382 8.95215Z",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99979 15.2379C8.57839 15.2379 9.04743 14.7688 9.04743 14.1902C9.04743 13.6116 8.57839 13.1426 7.99979 13.1426C7.42119 13.1426 6.95215 13.6116 6.95215 14.1902C6.95215 14.7688 7.42119 15.2379 7.99979 15.2379Z",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80969 8.95243V4.76186C3.80969 3.65045 4.2512 2.58456 5.03708 1.79868C5.82297 1.01279 6.88885 0.571289 8.00026 0.571289C9.11167 0.571289 10.1776 1.01279 10.9634 1.79868C11.7493 2.58456 12.1908 3.65045 12.1908 4.76186V8.95243",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.ea98a3fa2dc87c07a2da3447a51de1d8.svg";
export { ForwardRef as ReactComponent };